import {
	DEFERRED_QUEUES_LOADING,
	DEFERRED_QUEUES_GET,
	DEFERRED_QUEUES_ERROR,
	DEFERRED_ELEMENTS_LOADING,
	DEFERRED_ELEMENTS_GET,
	DEFERRED_ELEMENTS_ERROR,
	DEFERRED_COUNT_GET,
	DEFERRED_COUNT_ERROR
} from '../actions/types';

const initialState = {
	deferred_loading: false,
	deferred_queues: [],
	deferred_elements_loading: false,
	deferred_elements: { size: 0, elements: [] },
	deferred_count: 0,
	deferred_errors: {}
}

export default function deferredReducer(state = initialState, action){
	switch(action.type){
		case DEFERRED_QUEUES_LOADING:
			return { ...state, deferred_loading: action.payload }
		case DEFERRED_QUEUES_GET:
			delete state.deferred_errors.deferred_queues
			return { ...state, deferred_queues: action.payload.queues || action.payload }
		case DEFERRED_ELEMENTS_LOADING:
			return { ...state, deferred_elements_loading: action.payload }
		case DEFERRED_ELEMENTS_GET:
			delete state.deferred_errors.deferred_elements
			return { ...state, deferred_elements: action.payload }
		case DEFERRED_COUNT_GET:
			delete state.deferred_errors.deferred_count
			return { ...state, deferred_count: action.payload.count || 0 }
		case DEFERRED_QUEUES_ERROR:
		case DEFERRED_ELEMENTS_ERROR:
		case DEFERRED_COUNT_ERROR:
			return {
				...state,
				deferred_errors: {
					...state.deferred_errors,
					[`${action.payload.type}`]: { msg: action.payload.msg }
				}
			}
		default:
			return state;
	}
}
